/**
 * FilterAccordion Component
 * Collapsible accordion section for filters with hierarchical selection
 */

import React, { useState, useRef, useEffect } from 'react';
import '../styles/components/filterAccordion.css';

interface FilterAccordionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  selectedCount: number;
  children: React.ReactNode;
}

export const FilterAccordion: React.FC<FilterAccordionProps> = ({
  title,
  isExpanded,
  onToggle,
  selectedCount,
  children,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (isExpanded && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isExpanded, children]);

  return (
    <div className="filter-accordion">
      <button
        type="button"
        className={`filter-accordion-header ${selectedCount > 0 ? 'has-selections' : ''}`}
        onClick={onToggle}
      >
        <div className="filter-accordion-title">
          <svg
            className={`filter-accordion-chevron ${isExpanded ? 'expanded' : ''}`}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>{title}</span>
          {selectedCount > 0 && (
            <span className="filter-accordion-count">({selectedCount})</span>
          )}
        </div>
      </button>
      <div
        ref={contentRef}
        className="filter-accordion-content"
        style={{
          height: height !== undefined ? `${height}px` : 'auto',
          overflow: 'hidden',
          transition: 'height 0.2s ease-out'
        }}
      >
        <div className="filter-accordion-body">
          {children}
        </div>
      </div>
    </div>
  );
};
